import { Component, OnInit, OnDestroy, HostListener, Optional, Inject, AfterViewInit, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { PershingTranslationService, INavigationService, IContextService, IAppDataStore, AccountContextValue, CoreConstants, DomainContext, PershingHttpUtil } from '@pershing/pershing-core';
import { Idle, DocumentInterruptSource, StorageInterruptSource } from '@ng-idle/core';
import { MatDialog } from '@angular/material/dialog';
import { SessionTimeoutComponent } from '@pershing/nxi-portalcomponents';
import { filter } from 'rxjs/operators';
import { PortalConstants } from '../utils/portal.constants';
import { PathManipulation } from '../utils/path_manipulation';
import { NxiAuthService } from '../services/nxi-auth.service';
import { DOCUMENT, Location } from '@angular/common';
import { OneClickEnrollComponent } from '@pershing/edc-edelivery';
import { setDasfLoginScreenErrorMsg } from '../utils/portal.utils';
import { ComponentType } from '@angular/cdk/overlay';
import { ModernOneClickEnrollComponent } from '@pershing/edc-newedelivery';
import moment from 'moment';
// import { NxiContextUtils } from '@pershing/nxi-common';
const LANGUAGES = [
    { 'key': 'en', 'label': 'English' },
    { 'key': 'es', 'label': 'Español' }
];
declare let citilm: any;
@Component({
    selector: 'portal-app',
    templateUrl: 'portal.component.html'
})
export class PortalAppComponent implements OnDestroy, OnInit, AfterViewInit {
    isLoggedIn: boolean = false;
    step: string = 'login';
    isAdvisor: boolean = false;
    isDisclosures: boolean = false;
    hideHeaderFooter: boolean = false;
    languages = LANGUAGES;
    hideNav: boolean = false;
    hideHeader: boolean = false;
    hideFooter: boolean = false;
    showLogoOnly: boolean = false;
    hideLogoutButton: boolean = false;
    hideQuickQuote: boolean = false;
    hideOpenAccounLink: boolean = false;
    hideBreadCrumb: boolean = false;
    previousGoToView: string;
    routeValue: string;
    matDialogue = null;
    inSeconds: number = 60;
    sessionTimeOut: number;
    inmilliSeconds: number = this.inSeconds * 1000;
    keepAliveTimerInterval: number;
    isAdaTheme: boolean = false;
    isMobileTheme: boolean = false;
    isTabletTheme: boolean = false;
    showAdaPageContent: boolean = true;
    breadcrumbsval: string;
    ibdName: string = '';
    ibd: string = '';
    isSpanishEnabledIBD: boolean = false;
    getCommunityName: string;
    hideSecondLevelNav: boolean = false;
    inputValue: string = '';
    hashValue: string = '';
    isAccountOpeningPageADA: boolean = false;
    sessionTimeoutAlert: boolean = false;
    isCBOL: boolean = false;
    cbolObj: any = {};
    keepAliveId;
    keepAliveTimerActive: boolean = false;
    isLazyLoadOneTrustPage: boolean = false;
    oneTrustConfig: any = {};
    isModernTheme: boolean = false;
    isOneClickEdelShown: boolean = false;
    isGeneric: boolean = false;
    brandedUrl: string = '';
    ibdURL: string = '';
    showSiteTermsAndConditions: boolean = false;
    termsAndConditions: any;
    suppressTimeout: boolean = false;
    dfp: string = '';
    dasfLoginEnabled: boolean = false;
    isDataCollectionEnabled: boolean = false;
    hideMobileFooter: boolean = false;
    oneClickEnrollComponent: ComponentType<unknown>;
    showSessionTimer: boolean = true;
    lastUserAction: any;
    dojoPages: string[] = []; // list of dojoPages, for ex: ["/nxi/digital-advise-mixin", etc, etc]
    region: any;
    constructor(
        private translationService: PershingTranslationService,
        private router: Router,
        private navigationService: INavigationService,
        private contextService: IContextService,
        private appDataStore: IAppDataStore,
        private idle: Idle,
        private matDialog: MatDialog,
        private authService: NxiAuthService,
        private location: Location,
        private route: ActivatedRoute,
        @Optional() @Inject('AppSettings') appSettings: any,
        private renderer2: Renderer2,
        @Inject(DOCUMENT) private _document: Document) {
        let basePath = PathManipulation.getBasePath(appSettings);
        if (basePath != null) {
            this.translationService.addTranslationFolder('@pershing/nxi-ng-portal-common', basePath + '/lib');
        } else {
            this.translationService.addTranslationFolder('@pershing/nxi-ng-portal-common', '/lib');
        }
        // SuppressTimeout is used to suppress the timeout happening in Charts Preview in Sitebuilder
        this.suppressTimeout = appSettings.isSitebuilder && appSettings.previewSite;
        let parsemap = appSettings.ibdConfigMap;
        if(appSettings.isVendorSso && (appSettings.sessionTimeoutOfSSO)){
          this.sessionTimeOut = appSettings.sessionTimeoutOfSSO;
        } else {
          this.sessionTimeOut = parsemap.sessionTimeOut;
        }
        this.keepAliveTimerInterval = parsemap.keepAliveTimerInterval ? parsemap.keepAliveTimerInterval : 10;
        this.isLoggedIn = appSettings.isLoggedIn;
        this.isAdvisor = appSettings.isAdvisor;
        this.isModernTheme = appSettings.isModernTheme;
        this.region = appSettings.region;
        this.ibd = parsemap.IBD;
        if(this.isModernTheme) {
            this.oneClickEnrollComponent = ModernOneClickEnrollComponent;
        } else {
            this.oneClickEnrollComponent = OneClickEnrollComponent;
        }

        this.getCommunityName = parsemap.community;

        if (appSettings.dojoPages) {
            this.dojoPages = appSettings.dojoPages;
        }

        this.handleAppSettingsParams(appSettings);

    }

    handleAppSettingsParams(appSettings) {
      this.ibdName = !!appSettings.ibdConfigMap && !!appSettings.ibdConfigMap.ibdName ? appSettings.ibdConfigMap.ibdName : '';
      if ( appSettings.dasfLoginEnabled) {
          this.dasfLoginEnabled = appSettings.dasfLoginEnabled;
      }
      if (appSettings.ibdConfigMap.isDataCollectionEnabled) {
          this.isDataCollectionEnabled = true;
      }
      if ( appSettings.ibdConfigMap.showSiteTermsAndConditions) {
          this.showSiteTermsAndConditions = appSettings.ibdConfigMap.showSiteTermsAndConditions;
      }
      if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
          this.isMobileTheme = true;
      } else if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
          this.isTabletTheme = true;
      } else if (appSettings.themeType && appSettings.themeType === 'ada') {
          this.isAdaTheme = true;
      }
      if (appSettings.hideHeaderFooter) {
          this.hideHeaderFooter = appSettings.hideHeaderFooter;
      }

      this.handleLanguageSettings(appSettings);

      this.isGeneric = appSettings.ibdConfigMap.generic;
      this.isCBOL = appSettings.isCBOL;
      this.ibdURL = appSettings.ibdConfigMap.URL;
      this.cbolObj = appSettings.cbolObj || {};
      if (appSettings.isLazyLoadOneTrustPage) {
          this.isLazyLoadOneTrustPage = true;
          this.oneTrustConfig = appSettings.onetrustConfig;
      }
    }

    handleLanguageSettings(appSettings) {
      // checking for spanish enabled to show the language switch
      let spanishSiteEnabledIBDs = appSettings.ibdConfigMap.spanishSiteEnabledIBD;
      if (spanishSiteEnabledIBDs.includes(appSettings.ibdConfigMap.IBD) || (appSettings.ibdConfigMap.generic && appSettings.ibdConfigMap.community === 'netxinvestor')) {
          this.isSpanishEnabledIBD = true;
      }
    }

    switchLanguage(language: string) {
        this.translationService.use(language);
    }
    @HostListener('document:nxiDuplicateEvent', ['$event'])
    duplicateEventHandle(event: any) {
        console.log(' In sessionexist event');
        this.router.navigateByUrl('nxi/sessionexist');
    }
    @HostListener('document:nxiRedirectLoginPageEvent', ['$event'])
    redirectEventHandle(event: any) {
        console.log(' In redirect event');
        if (event.detail && event.detail.errorMessage) {
            this.contextService.setRouteContext(event.detail);
        }
        this.router.navigateByUrl('nxi/login?login=true');
    }
    @HostListener('document:nxiOTPEvent', ['$event'])
    otpEventHandle(event: any) {
        console.log(' In otp event');
        this.router.navigateByUrl('nxi/otp');
    }
    @HostListener('document:nxiSetUpEvent', ['$event'])
    setupEventHandle(event: any) {
        console.log(' In otp setup event');
        this.router.navigateByUrl('nxi/otpSetup');
    }
    @HostListener('document:visibilitychange')
    visibilitychange() {
        if(!document.hidden){
            let elapsedTime = this.getMinutesBetween(this.lastUserAction, Date.now());
            if( elapsedTime < (this.sessionTimeOut * this.inSeconds)){
                this.showSessionTimer=true;
            } else {
                this.showSessionTimer =  false;
            }
        }
    }

    getMinutesBetween(lastUserAction: any, currentTime: any) {
        let elapsedTime = currentTime - lastUserAction;
        return elapsedTime/1000;
    }

    @HostListener('document:nxiLogonEvent', ['$event'])
    saEventHandle(event: any) {
        console.log(' In sa event' + event.detail);
        if (event.detail.dasfDetails && event.detail.page) {
            // Update the acl details from dasf response in appsettings
            this.brandedUrl = '';
            let userId = event.detail.dasfDetails.userid;
            let ibd = event.detail.dasfDetails.corrnum;
            if (event.detail.dasfDetails.dfp && this.dfp === '') {
                this.dfp = event.detail.dasfDetails.dfp;
            }
            if (this.showSiteTermsAndConditions && event.detail.page !== 'midlogindasf') {
                this.authService.showSiteTermsAndConditions(userId, ibd).subscribe(
                    response => {
                        this.termsAndConditions = response;
                        if (this.termsAndConditions ) {
                            this.contextService.setRouteContext('');
                            this.navigationService.setContextAndNavigate('', '', '/nxi/midlogintc');
                            this.contextService.setRouteContext(event.detail);
                            return;
                        }
                    },
                    error => {
                        console.log(error);
                    }
                );
            }

            if (event.detail.dasfDetails.Response && event.detail.page === 'midlogindasf' && !window.location.search.includes('token')) {
                let userSourceCode: string = '';
                let dbReturnCode: string = '';
                if (event.detail.nxiDetails && event.detail.nxiDetails.userSourceCode) {
                    userSourceCode = event.detail.nxiDetails.userSourceCode;
                }
                if (event.detail.nxiDetails && event.detail.nxiDetails.DBReturnCode) {
                    dbReturnCode = event.detail.nxiDetails.DBReturnCode;
                }

                this.authService.getBrandedRedirect(userId, ibd, userSourceCode, this.dfp, dbReturnCode).subscribe(
                    response => {
                        if (response.siteAccessErrorMsg && response.siteAccessErrorMsg !== '') {
                            setDasfLoginScreenErrorMsg(response.siteAccessErrorMsg);
                            this.router.navigateByUrl('nxi/login?login=true');
                            return;
                        }
                        if (response.potentialUserErrorMsg &&  response.potentialUserErrorMsg !== '') {
                            setDasfLoginScreenErrorMsg(response.potentialUserErrorMsg);
                            let reloadParam = { reload: (new Date).getTime() };
                            this.router.navigate(['/nxi/welcome', reloadParam], {queryParams : {login:'true'}});
                            return;
                        }
                        this.brandedUrl = response.brandedUrl;
                        console.log('Branded URL is ' + this.brandedUrl);
                        if (response.brandedUrl && !this.brandedUrl.includes(this.ibdURL)) {
                            let url = this.brandedUrl.split('?')[0];
                            console.log('URL got is ' + url);
                            url = url.replace('login', event.detail.page);
                            // console.log('URL to post is ' + url);
                            let form = document.createElement('form');
                            form.action = url;
                            form.method = 'POST';
                            let input = document.createElement('input');
                            input.name = 'dasfstorage';
                            let appSettings = (window as any).appSettings;
                            if (appSettings.companyName) {
                                event.detail.companyName = appSettings.companyName;
                                event.detail.custServicePhoneNum = appSettings.custServicePhoneNum;
                                event.detail.techSupportPhoneNum = appSettings.techSupportPhoneNum;
                                event.detail.custServiceEmailAddress = appSettings.custServiceEmailAddress;
                            }
                            if (appSettings.brandInd) {
                                event.detail.brandInd = appSettings.brandInd;
                            }
                            input.value = escape(JSON.stringify(event.detail));
                            input.type = 'hidden';
                            form.appendChild(input);
                            document.body.appendChild(form);
                            form.submit();
                        } else {
                            this.contextService.setRouteContext('');
                            this.navigationService.setContextAndNavigate('', '', '/nxi/' + event.detail.page);
                            this.contextService.setRouteContext(event.detail);
                        }
                    }
                );
            } else {
                this.contextService.setRouteContext('');
                this.navigationService.setContextAndNavigate('', '', '/nxi/' + event.detail.page);
                this.contextService.setRouteContext(event.detail);

            }
        } else {
            this.router.navigateByUrl('nxi/welcome');
        }
    }
    @HostListener('document:nxiSetUpQAEvent', ['$event'])
    sasetupEventHandle(event: any) {
        console.log(' In otp event');
        this.router.navigateByUrl('nxi/saSetup');
    }
    @HostListener('document:nxiChangePasswordEvent', ['$event'])
    changePwdEventHandle(event: any) {
        console.log(' In otp event');
        this.router.navigateByUrl('nxi/changepwd');
    }
    @HostListener('document:nxiUpdateSecEvent', ['$event'])
    securityEmailEventHandle(event: any) {
        console.log(' In otp event');
        this.router.navigateByUrl('nxi/securityEmail');
    }
    @HostListener('document:nxiLoginEvent', ['$event'])
    loginEventHandle(event: any) {
        console.log(' In login event  DASF Details' + event.detail.dasfDetails);
        if (event.detail.dasfDetails) {

            let userId = event.detail.dasfDetails.userid;
            if (!this.ibd && event.detail.dasfDetails.corrnum) {
                this.ibd = event.detail.dasfDetails.corrnum;
            }
            let lastLogin = '';
            if (event.detail.dasfDetails.lastSignonDate) {
               console.log('Last login date' + event.detail.dasfDetails.lastSignonDate);
               lastLogin = event.detail.dasfDetails.lastSignonDate;
            }
            this.contextService.setRouteContext('');
            this.authService.redirectToNxiLandingPage(userId, this.ibd, lastLogin, this.dfp).subscribe(
                response => {
                    let url = '/nxi/redirectLandingPage?landingPage=default';
                    if (response) {
                        let landingPage = response.landingPage ? response.landingPage : 'default';
                        url = '/nxi/redirectLandingPage?landingPage=' + landingPage;
                        if (response.communityName) {
                            url = url + '&communityName=' + response.communityName;
                        }
                        if (response.themeType) {
                            url = url + '&userThemeType=' + response.themeType;
                        }
                        if (response.isModern) {
                            url = url + '&isModern=' + response.isModern;
                        }
                    }
                    if (event.detail) {
                        //  location.replace(event.detail.replace('/nxi/login', url));
                        // this.contextService.setRouteContext(event.detail);
                        // this.router.navigateByUrl(url);
                        // location.replace(url);
                        location.href = url;
                    } else {
                        location.href = url;
                    }
                },
                error => {
                    console.log(error);
                    if (event.detail) {
                        location.replace(event.detail);
                    }
                    document.dispatchEvent(new CustomEvent('portal.gotoview', {
                        detail: {
                            'gotoPage': '/nxi/welcome'
                        }
                    }));
                }
            );
        } else {
            document.dispatchEvent(new CustomEvent('portal.gotoview', {
                detail: {
                    'gotoPage': '/nxi/welcome'
                }
            }));
        }
    }

    @HostListener('document:timeoutEvent', ['$event'])
    timeoutEventHandle(event: any) {
        if (event.detail.status === 'continue') {
            this.authService.invokeKeepAlive().subscribe();
            this.matDialogue = null;
            this.invokeIdleWatch();
        } else {
            this.authService.logout('timedOut');
        }
    }

    @HostListener('document:nxiAclEvent', ['$event'])
    aclupdate(event: any) {
        if(window['adobeDataLayer']){
            let taggedValue ={event : 'callToAction', 
                              attributes : { 
                                page : {
                                  friendlyName : document.querySelector('title').innerText.split("-")[1] ? document.querySelector('title').innerText.split("-")[1] : "" , pageTitle : document.querySelector('title').innerText , canonicalURL :  window.location.protocol + '//' + window.location.host , fullURL : document.location.href
                                }, 
                                element : { 
                                  componentName : document.querySelector('title').innerText.split("-")[1] ? document.querySelector('title').innerText.split("-")[1] : "" } ,
                                appPath : { loginResult : "attempted login"},
                                timestamp : moment(new Date()).format('HH:mm:ss.SSS'),
                                environment : this.region,
                                siteVersion : "NETXinvestor" 
                              }
                              };
            window['adobeDataLayer'].push(taggedValue);
          }
        if (event.detail.acl) {
            this.captureAndSetACLDetails(event.detail);
        }
    }

    invokeIdleWatch() {
        this.idle.watch();
    }

    captureAndSetACLDetails(dasfResponse: any) {
        let parserResponse = dasfResponse;
        let appSettings = (window as any).appSettings;
        if (parserResponse && parserResponse.acl && parserResponse.acl[0] && parserResponse.acl[0].aclIbd) {
            appSettings.companyName = parserResponse.acl[0].aclIbd.companyName;
            appSettings.custServicePhoneNum = parserResponse.acl[0].aclIbd.custServicePhoneNum;
            appSettings.techSupportPhoneNum = parserResponse.acl[0].aclIbd.techSupportPhoneNum;
            appSettings.custServiceEmailAddress = parserResponse.acl[0].aclIbd.custServiceEmailAddress;
            if (parserResponse.acl[0].aclSitesList && parserResponse.acl[0].aclSitesList[0]) {
                appSettings.brandInd = parserResponse.acl[0].aclSitesList[0].brandInd;
            }
        }
    }
    SetACLDetailsforafterreload(data: any) {
        if (data) {
        let appSettings = (window as any).appSettings;
        if (data.companyName) {
            appSettings.companyName = data.companyName;
            appSettings.custServicePhoneNum = data.custServicePhoneNum;
            appSettings.techSupportPhoneNum = data.techSupportPhoneNum;
            appSettings.custServiceEmailAddress = data.custServiceEmailAddress;
        }
        if (data.brandInd) {
            appSettings.brandInd = data.brandInd;
        }
    }
    }
    createDefaultInterruptSources(options?) {
        return [new DocumentInterruptSource('keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll', options),
        new StorageInterruptSource()];
    }

    // uncomment if required
    // clearKeepAliveTimer() {
    //     if (this.keepAliveTimerActive && this.keepAliveId) {
    //         clearInterval(this.keepAliveId);
    //         this.keepAliveTimerActive = false;
    //     }
    // }
    sessionTimeOutWarning(prelogin = false) {
        if (!this.sessionTimeoutAlert && !this.suppressTimeout) {
            // set the idle time period from ldap before invoking the popup screen.
            this.idle.setIdle(this.sessionTimeOut * this.inSeconds);
            this.sessionTimeoutAlert = true;
            // setsÂ theÂ defaultÂ interrupts likeÂ clicks,Â scrolls,
            // touchesÂ toÂ theÂ document
            this.idle.setInterrupts(this.createDefaultInterruptSources());
            // this.idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
            // invoking the popup after 19 mins.
            this.idle.onInterrupt.subscribe(() => {
                this.lastUserAction = Date.now();
            });
            this.idle.onIdleStart.subscribe(() => {
                // for prelogin pages - it should not display
                // popup. Invoked logout for prelogin timeout pages
                if (!prelogin && this.showSessionTimer && !document.hidden) {
                    if (!this.matDialogue) {
                        this.matDialogue = this.matDialog.open(SessionTimeoutComponent, { width: '507px', panelClass: ['modal'] });
                    }
                } else {
                    this.authService.logout('timedOut');
                }
            });
            // create a keepalive timer to keep backend session
            // active if user is doing some activity that
            // does not touch session
            if (!prelogin && !this.keepAliveTimerActive) {
                this.keepAliveTimerActive = true;
                this.keepAliveId = setInterval(() => {
                    this.authService.invokeKeepAlive().subscribe();
                }, this.keepAliveTimerInterval * this.inmilliSeconds);
            }
            // Enabling the idle watch
            this.invokeIdleWatch();
        }
    }
    ngAfterViewInit() {
        if (this.isCBOL && this.cbolObj && !this.cbolObj.enableCbolRestBranding && citilm) {
            citilm.loadCitiBrand();
            citilm.loadCitiFooter();
        }
    }
    ngOnInit() {
        document.dispatchEvent(new CustomEvent('portal.breadcrumbs'));
        console.log(' In PortalAppComponent OnInit ');
        let removeLoadingAnimation = new CustomEvent('portal.removeLoadingAnimation');
        document.dispatchEvent(removeLoadingAnimation);
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                console.log(' In PortalAppComponent router event ');
                const tree = this.router.parseUrl(this.router.url);
                if (tree.fragment) {
                    const element = document.querySelector('#' + tree.fragment);
                    if (element) { element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' }); }
                }
                let requestUrl = event.url;
                console.log('request url after router event - ' + requestUrl);
                if (this.isDataCollectionEnabled) {
                    if (requestUrl.includes('midlogin') || requestUrl.includes('nxi/otp') || requestUrl.includes('nxi/sa')) {
                        this.emitPageDetails('security_question');
                    } else if (requestUrl.includes('fundstransfer') || requestUrl.includes('neworder')) {
                        this.emitPageDetails('transaction');
                    } else if (requestUrl.includes('settings') || requestUrl.includes('changepassword') || requestUrl.includes('postlogin-security') || requestUrl.includes('resetpassword') || requestUrl.includes('changepwd') || requestUrl.includes('updateSec') || requestUrl.includes('securityEmail')) {
                        this.emitPageDetails('change_details');
                    } else if (requestUrl.includes('payee')) {
                        this.emitPageDetails('add_payee');
                    } else if (!(requestUrl.includes('welcome')) && !(requestUrl.includes('login')) && !(requestUrl.includes('overview'))) {
                        this.emitPageDetails('other');
                    }
                }
                let urlArray = requestUrl.split('/');
                if (urlArray[urlArray.length - 1].split('?').length > 1) {
                    urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('?')[0];
                } else if (urlArray[urlArray.length - 1].split('#').length > 1) {
                    urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('#')[0];
                } else if (urlArray[urlArray.length - 1].split(';').length > 1) {
                    urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split(';')[0];
                }
                let lastIndex = urlArray[urlArray.length - 1];
                if (lastIndex === 'nxi' || lastIndex === 'login' || lastIndex === 'welcome') {
                    this.routeValue = 'login';
                    if (localStorage.getItem('awrDataContext')) {
                        localStorage.removeItem('awrDataContext');
                    }
                } else {
                    this.routeValue = lastIndex;
                }
                document.getElementsByTagName('title')[0].innerText = this.ibdName + ' - ' + this.translationService.translate.instant(this.routeValue);
                if (urlArray[2] === 'disclosure') {
                    this.step = 'disclosure';
                    this.isDisclosures = true;
                }
                if (PortalConstants.PreloginPagesList.indexOf(lastIndex) !== -1 || lastIndex === ' ' || lastIndex.includes('welcome;reload=')) {
                    this.step = 'login';
                    this.isLoggedIn = false;
                    if (this.isAdaTheme && lastIndex.includes('account-info-entry-nao') || lastIndex.includes('account-status-nao') ||
                        lastIndex.includes('account-types-nao') || lastIndex.includes('account-creation-info-nao') ||
                        lastIndex.includes('account-verid-nao') || lastIndex.includes('account-verid-qa-nao') || lastIndex.includes('account-new-userid-nao') ||
                        lastIndex.includes('what-next') || lastIndex.includes('add-fundstransfer')) {
                        this.isAccountOpeningPageADA = true;
                    } else {
                        this.isAccountOpeningPageADA = false;
                    }
                    this.showLogoOnly = true;
                    if (PortalConstants.PreLoginSessionTimeoutPages.indexOf(lastIndex) !== -1) {
                        console.log('Session timeout invoked for prelogin view ', lastIndex);
                        this.sessionTimeOutWarning(true);
                        if (lastIndex === 'duplicatesessionconfirmation') {
                            this.showLogoOnly = true;
                            this.hideLogoutButton = true;
                        }
                    }
                    if (lastIndex.includes('account-types-nao') || lastIndex.includes('account-creation-info-nao') ||
                        lastIndex.includes('account-verid-nao') || lastIndex.includes('account-verid-qa-nao') || lastIndex.includes('account-new-userid-nao') ||
                        lastIndex.includes('"digital-advise-splash') || lastIndex.includes('digital-advise-mixin')) {
                        console.log('accopeng pages' + this.sessionTimeoutAlert);
                        if (!this.sessionTimeoutAlert) {
                            console.log('sessiontimeout' + this.sessionTimeOut);
                            this.idle.setIdle(this.sessionTimeOut * this.inSeconds);
                            this.sessionTimeoutAlert = true;
                            this.idle.setInterrupts(this.createDefaultInterruptSources());
                            console.log('before redirection 1');
                            this.idle.onIdleStart.subscribe(() => {
                                console.log('before redirection 2');
                                this.authService.logout('timedOut');
                            });
                            this.invokeIdleWatch();
                        }
                    }
                } else {
                    this.step = 'postLogin';
                    this.isLoggedIn = true;
                    if (this.isAdaTheme && lastIndex.includes('account-info-entry-nao') || lastIndex.includes('account-status-nao') ||
                        lastIndex.includes('account-types-nao') || lastIndex.includes('account-creation-info-nao') ||
                        lastIndex.includes('account-verid-nao') || lastIndex.includes('account-verid-qa-nao') || lastIndex.includes('account-new-userid-nao') ||
                        lastIndex.includes('what-next') || lastIndex.includes('add-fundstransfer') || lastIndex.includes('dt-consent')
                        || lastIndex.includes('prospectAccount-login')
                        || lastIndex.includes('dtAccountTransferConfirm') || lastIndex.includes('prospectAccounts')) {
                        this.isAccountOpeningPageADA = true;
                    } else {
                        this.isAccountOpeningPageADA = false;
                    }
                    if (this.isLoggedIn) {
                        this.sessionTimeOutWarning();
                    }
                    if (!this.isOneClickEdelShown) {
                        this.authService.isOneClickEdelEnabled().subscribe(
                            response => {
                                if (response && response.showOneClickEdel) {
                                    let isshowInterstitial = false;
                                    if (response.forceEnrollFlag === 'Y') {
                                        isshowInterstitial = true;
                                    }
                                    if (this.matDialog.openDialogs.length === 0) {
                                            this.matDialog.open(this.oneClickEnrollComponent, {
                                                panelClass: ['modal', 'edel-OneClick'],
                                                disableClose: true,
                                                data: {
                                                    showInterstitial: isshowInterstitial,
                                                    goPaperless: response.showOneClickFromGopaperless,
                                                    suppressOneClickEnrollCancel: response.suppressOneClickEnrollCancel
                                                }
                                        });

                                    }
                                    this.isOneClickEdelShown = true;
                                }
                            },
                            error => {
                                console.log(error);
                            }
                        );
                    }
                }
                let hideNavigation = false;
                let hideHeaderComp = false;
                this.hideLogoutButton = false;
                this.hideQuickQuote = false;
                let hideFooterComp = false;
                this.hideBreadCrumb = false;
                this.hideOpenAccounLink = false;
                console.log('request url before hide nav list - ' + requestUrl);
                PortalConstants.HideNavList.forEach(element => {
                    if (requestUrl.includes(element.pageName, 2)) {
                        hideNavigation = element.hideNavigation;
                        hideHeaderComp = element.hideHeader;
                        hideFooterComp = element.hideFooter;
                        this.showLogoOnly = element.showLogoOnly;
                        this.hideLogoutButton = element.hideLogoutButton;
                        this.hideQuickQuote = element.hideQuickQuote;
                        if (!!element.hideBreadCrumb) {
                            this.hideBreadCrumb = element.hideBreadCrumb;
                        }
                        if (!!element.hideOpenAccounLink) {
                            this.hideOpenAccounLink = element.hideOpenAccounLink;
                        }
                    }
                });
                this.hideNav = hideNavigation;
                this.hideHeader = hideHeaderComp;
                this.hideFooter = hideFooterComp;
            });
        if (sessionStorage.getItem('DASFResponse')) {
            this.contextService.setRouteContext(JSON.parse(unescape(sessionStorage.getItem('DASFResponse'))));
            this.SetACLDetailsforafterreload(JSON.parse(unescape(sessionStorage.getItem('DASFResponse'))));
            sessionStorage.removeItem('DASFResponse');
        }
        if (sessionStorage.getItem('DASFDfp')) {
            this.dfp = JSON.parse(sessionStorage.getItem('DASFDfp'));
            sessionStorage.removeItem('DASFDfp');
        }
        if (this.isCBOL && this.cbolObj && this.cbolObj.enableCbolRestBranding ) {
            this.authService.fetchCbolBranding(this.cbolObj).subscribe(
                response => {
                    const cbolrespscript = this.renderer2.createElement('script');
                    this.renderer2.setProperty(
                        cbolrespscript,
                        'text',
                        `${response}`
                    );
                    this.renderer2.appendChild(this._document.body, cbolrespscript);
                    setTimeout(() => {
                        citilm.loadCitiBrand();
                        citilm.loadCitiFooter();
                    }, 2000);
                }
            );
        }
        this.hideFooterBasedOnComunity();
    }
    hideFooterBasedOnComunity() {
        if(!this.isMobileTheme && !this.isTabletTheme){
            if (this.getCommunityName == 'wealthgen' && this.isLoggedIn) {
                this.hideHeaderFooter = false;
            } else if (this.getCommunityName == 'wealthgen' && !this.isLoggedIn) {
                this.hideHeaderFooter = true;
            }
        }else {
            if (this.getCommunityName == 'wealthgen' && this.isLoggedIn) {
                this.hideMobileFooter = false;
            } else if (this.getCommunityName == 'wealthgen' && !this.isLoggedIn) {
                this.hideMobileFooter = true;
            }
        }
    }
    public ngOnDestroy() {
        console.log(' In PortalAppComponent Destroy ');
    }

	emitPageDetails(action) {
        let emitFrameDetails = new CustomEvent('portal.emitFrameDetails',{detail:action});
        document.dispatchEvent(emitFrameDetails);
    }

    cookieNotice() {
        let pagePath = '/nxi/privacy-policy/cookie-notice-policy';
        let url = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + pagePath;
        let PcEl = document.getElementsByClassName('menu-item-moreinfo')[0];
        if ((PcEl !== null && PcEl !== undefined) && (PcEl.firstChild !== null && PcEl.firstChild !== undefined)) {
            let PcTarget = PcEl.firstChild.firstChild;
            if (PcTarget !== null && PcTarget !== undefined) {
                // PcTarget.setAttribute('href', url);
                // PcTarget.setAttribute('target', '_self');
            }
        }
        let BanTarget = document.getElementsByClassName('banner-policy-link')[0];
        BanTarget.setAttribute('href', url);
        BanTarget.setAttribute('target', '_self');
    }
    navigateBySettingHref(gotoPage: string): void {
        location.href = gotoPage;
    }
    getLocationHref(): string {
        return location.href;
    }
    /**
     * If user is navigating between dojo and non-dojo page using the document:portal.gotoview
     * will do a full page refresh by setting location.href
     * @param pageToGo The page that user is navigating to
     */
    handlingNavigationBetweenDojoAndNonDojo(pageToGo: string): boolean {
        let isCurrentlyOnDojoPage: boolean = false;
        let isNavigatingToDojoPage: boolean = false;
        let currentUrl = this.getLocationHref();
        this.dojoPages.forEach((dojoPage) => {
            let regex = new RegExp(dojoPage + '([/?#;]+|$)', 'g');
            if (!isCurrentlyOnDojoPage) { // check every dojoPages until it's become true
                let found = currentUrl.match(regex);
                isCurrentlyOnDojoPage = !!found;
            }
            if (!isNavigatingToDojoPage) {
                let found = pageToGo.match(regex);
                isNavigatingToDojoPage = !!found;
            }
        });
        let reload = isCurrentlyOnDojoPage != isNavigatingToDojoPage
        if (reload) { // do full page reload if we are navigating between non dojo and dojo
            this.navigateBySettingHref(pageToGo + '#main-container');
        }
        return reload;

    }
    /* gotoView listener */
    @HostListener('document:portal.gotoview', ['$event'])
    gotoEvent(event: any) {
        let context: any = event.detail.context;
        let params: any = event.detail.gotoParams;
        let page: string = event.detail.gotoPage;
        let value: any = null;
        let domain: string = null;
        let dojoAndNonDojoNavigation = false;
        if (params) {
            params = PershingHttpUtil.getQueryStringFromJsonObject(params);
            this.contextService.setRouteContext(params);
            dojoAndNonDojoNavigation = this.handlingNavigationBetweenDojoAndNonDojo(page + '?' + params);
        } else {
            // reset goto on subsequent navigation
            this.contextService.setRouteContext('');
            dojoAndNonDojoNavigation = this.handlingNavigationBetweenDojoAndNonDojo(page);
        }
        if (dojoAndNonDojoNavigation) {
            return; // stop the execution because the page should refresh
        }
        if (context) {
            domain = context.domain;
            value = context.value;
        }
        if (domain === CoreConstants.ACCOUNT && !(value instanceof DomainContext) && this.isLoggedIn) {
            let acctList = this.appDataStore.get('ACCOUNTS_LIST');
            if (!!acctList) {
                for (let i = 0; i < acctList.length; i++) {
                    if (acctList[i].acctReference === value) {
                        let account: any = acctList[i];
                        let accountContextValue: AccountContextValue = new AccountContextValue(account.acctNo, value);
                        if (account.acctNo === 'ALL') {
                            accountContextValue.accountNumber = 'ALL_ACCOUNTS';
                        } else if (account.acctNo) {
                            accountContextValue.accountNumber = account.acctNo;
                        } else {
                            accountContextValue.accountNumber = account.groupId;
                        }
                        accountContextValue.hashValue = account.acctReference;
                        accountContextValue.accountType = account.acctTypeCode;
                        value = accountContextValue;
                        break;
                    }
                }
            }
        }
        let result = this.navigationService.setContextAndNavigate(domain, value, page);
        if (result) {
            result.then(response => {
                if (this.previousGoToView === page) {
                    let modRefreshEvent = new CustomEvent('portal.refreshmodview');
                    document.dispatchEvent(modRefreshEvent);
                } else {
                    this.previousGoToView = page;
                }
            });
        }
        this.hideSecondLevelNav = false;
    }
    @HostListener('document:portal.LogoutEvent')
    logout() {
        if (this.dasfLoginEnabled) {
            console.log('Calling DASF logout method');
            this.authService.invokeDasfLogout();
        } else {
            console.log('Calling NXI logout method');
            this.authService.logout();
        }
    }

    @HostListener('document:portal.DASFLogoutEvent')
    invokeDasflogout() {
        this.authService.invokeDasfLogout();
    }

    @HostListener('document:portal.browserTitleValue', ['$event'])
    UpdateBrowserTitle(event: any) {
        document.getElementsByTagName('title')[0].innerText = this.ibdName + ' - ' + this.translationService.translate.instant(event.detail.titleValue);
        const classes: string = document.body.getAttribute('class');
        if (classes && classes.length > 0) {
            const classList: string[] = classes.split(' ');
            const updatedClassList = classList.filter((c: string) => !c.startsWith('page-'));
            updatedClassList.push('page-' + event.detail.titleValue.split(/[. ]+/).pop().toLowerCase());
            document.body.setAttribute('class', updatedClassList.join(' '));
        } else {
            document.body.setAttribute('class', 'page-' + event.detail.titleValue.split(/[. ]+/).pop().toLowerCase());
        }
        this.hideSecondLevelNav = false;
    }
    @HostListener('document:portal.hidesecondlevelnav', ['$event'])
    hidesecondlevelnavEvent(event: any) {
        if (!!event.detail.hideSecondlevelNav) {
            this.hideSecondLevelNav = event.detail.hideSecondlevelNav;
        } else {
            this.hideSecondLevelNav = false;
        }
    }
    /*for iPhone and iPad not support "beforeunload" so need to use "pagehide" */
    @HostListener('window:pagehide')
    /* OnBeforeUnload event(page refresh/open in new tab) populates the selected domain context in browser LocalStorage. */
    @HostListener('window:beforeunload')
    OnBeforeUnload() {
        if (this.contextService.getRouteContext()) {
            let contextdetails: any = this.contextService.getRouteContext();
            let appSettings = (window as any).appSettings;
            if (appSettings.companyName) {
                contextdetails.companyName = appSettings.companyName;
                contextdetails.custServicePhoneNum = appSettings.custServicePhoneNum;
                contextdetails.techSupportPhoneNum = appSettings.techSupportPhoneNum;
                contextdetails.custServiceEmailAddress = appSettings.custServiceEmailAddress;
            }
            if (appSettings.brandInd) {
                contextdetails.brandInd = appSettings.brandInd;
            }
            sessionStorage.setItem('DASFResponse', JSON.stringify(contextdetails));
            sessionStorage.setItem('DASFDfp', JSON.stringify(this.dfp));
        }
        if (this.authService.isValid()) {
            this.contextService.saveLocalStorage();
        }
    }
    @HostListener('document:pershing.content.management.placeontrust')
    plcaeOntrust() {
        if (this.isLazyLoadOneTrustPage && this.oneTrustConfig) {
            const ele = document.createElement('script');
            ele.setAttribute('type', 'text/javascript');
            ele.setAttribute('src', this.oneTrustConfig.oneTrustScriptAutoblock);
            document.head.appendChild(ele);
            const stubele = document.createElement('script');
            stubele.setAttribute('type', 'text/javascript');
            stubele.setAttribute('src', this.oneTrustConfig.oneTrustScriptSdkStub);
            stubele.setAttribute('data-domain-script', this.oneTrustConfig.oneTrustDataDomainAttribute);
            document.head.appendChild(stubele);
        }
    }

    @HostListener('document:portal.oneClickEvent', ['$event'])
    invokeOneClickEvent(event: any) {
        let isshowInterstitial = false;
        if (event.detail.forceEnrollFlag === 'Y') {
            isshowInterstitial = true;
        }
        if (this.matDialog.openDialogs.length === 0) {

                this.matDialog.open(this.oneClickEnrollComponent, {
                    panelClass: ['modal', 'edel-OneClick'],
                    disableClose: true,
                    data: {
                        showInterstitial: isshowInterstitial,
                        goPaperless: event.detail.goPaperless,
                        suppressOneClickEnrollCancel: event.detail.suppressOneClickEnrollCancel
                    }
                });

        }
    }

}
